import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../../supabaseClient';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

// IMPORT EXACT DEPUIS SRC/ASSETS
// On remonte de 3 dossiers : components -> homepage -> pages -> SRC
// Puis on rentre dans assets
import heroImage from '../../../assets/hero-image.jpg';

const HeroSection = () => {
  const [stats, setStats] = useState({ schools: 0, students: 0 });
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkUser = async () => {
        const { data: { user } } = await supabase.auth.getUser();
        setUser(user);
    };
    
    const fetchStats = async () => {
        const { count: schoolsCount } = await supabase.from('schools').select('*', { count: 'exact', head: true });
        const { count: studentsCount } = await supabase.from('profiles').select('*', { count: 'exact', head: true });
        setStats({ 
            schools: schoolsCount || 0, 
            students: studentsCount || 0 
        });
    };

    checkUser();
    fetchStats();
  }, []);

  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-green-50 py-16 lg:py-24 overflow-hidden">
      <div className="absolute inset-0 bg-white/60"></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium">
                <Icon name="Compass" size={16} />
                <span>Orientation Académique Personnalisée</span>
              </div>
              <h1 className="text-4xl lg:text-5xl font-heading font-bold text-foreground leading-tight">
                Ton Avenir, <br />
                <span className="text-primary">Ton Choix, Ta Réussite.</span>
              </h1>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Découvre les meilleures écoles supérieures au Maroc (ENCG, ENSA, FMP...). 
                Trouve la formation qui correspond à tes notes et tes ambitions grâce à notre assistant intelligent.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              {user ? (
                  <Button 
                    variant="default" 
                    size="lg"
                    iconName="LayoutDashboard"
                    iconPosition="left"
                    className="flex-1 sm:flex-none"
                  >
                    <Link to="/student-profile" className="block w-full">
                      Mon Tableau de Bord
                    </Link>
                  </Button>
              ) : (
                  <Button 
                    variant="default" 
                    size="lg"
                    iconName="UserPlus"
                    iconPosition="left"
                    className="flex-1 sm:flex-none"
                  >
                    <Link to="/login" className="block w-full">
                      Commencer maintenant
                    </Link>
                  </Button>
              )}
              
              <Button 
                variant="outline" 
                size="lg"
                iconName="Search"
                iconPosition="left"
                className="flex-1 sm:flex-none"
              >
                <Link to="/post-bac-database" className="block w-full">
                  Explorer les Écoles
                </Link>
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center space-x-6 pt-4">
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Users" size={16} className="text-secondary" />
                <span>
                    {stats.students > 100 ? `+${stats.students}` : '100+'} étudiants inscrits
                </span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="School" size={16} className="text-secondary" />
                <span>
                    {stats.schools > 0 ? `+${stats.schools}` : '+50'} écoles référencées
                </span>
              </div>
            </div>
          </div>

          {/* Hero Image Section */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-blue-50 w-full h-[400px] lg:h-[500px]">
              
              {/* IMAGE IMPORTÉE DEPUIS SRC/ASSETS */}
              <img
                src={heroImage}
                alt="Université Al Akhawayn Ifrane"
                className="w-full h-full object-cover"
                style={{ minHeight: '100%' }}
                onError={(e) => {
                    // Si ça échoue encore, on met un fond gris pour ne pas avoir de carré vide
                    e.target.style.display='none';
                    e.target.parentElement.style.backgroundColor = '#cbd5e1'; 
                }} 
              />
              
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
            </div>
            
            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -left-6 bg-card border border-border rounded-xl p-4 shadow-xl z-20">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <Icon name="CheckCircle" size={24} className="text-green-600" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-foreground">100%</div>
                  <div className="text-sm text-muted-foreground">Gratuit & Accessible</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;